"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleTypesEnum = exports.AuthRoleEnum = exports.RoleTypeEnum = void 0;
var RoleTypeEnum;
(function (RoleTypeEnum) {
    RoleTypeEnum["INSTRUCTOR"] = "instructor";
})(RoleTypeEnum = exports.RoleTypeEnum || (exports.RoleTypeEnum = {}));
var AuthRoleEnum;
(function (AuthRoleEnum) {
    AuthRoleEnum["BACKOFFICE"] = "backoffice";
    AuthRoleEnum["ADMIN"] = "admin";
})(AuthRoleEnum = exports.AuthRoleEnum || (exports.AuthRoleEnum = {}));
var RoleTypesEnum;
(function (RoleTypesEnum) {
    RoleTypesEnum["DEFAULT"] = "default";
    RoleTypesEnum["CUSTOM"] = "custom";
    // All the rows below should be removed
    //region AuthRoles
    RoleTypesEnum["Admin"] = "Admin";
    RoleTypesEnum["Backoffice"] = "backoffice";
    //endregion
    //region RoleTypes
    RoleTypesEnum["Instructor"] = "instructor";
    RoleTypesEnum["BackwardCompatibility"] = "backward-compatibility";
    RoleTypesEnum["FrontDesk"] = "Front Desk";
    RoleTypesEnum["Kiosk"] = "Kiosk Staff";
    RoleTypesEnum["BondAdmin"] = "Bond Admin";
    RoleTypesEnum["EmployeeManager"] = "Employee Manager";
    RoleTypesEnum["ProgramsDirector"] = "Programs Director";
    RoleTypesEnum["MembershipsDirector"] = "Memberships Director";
    RoleTypesEnum["Marketing"] = "Marketing";
    RoleTypesEnum["Accountant"] = "Accountant";
    RoleTypesEnum["MaintenanceStaff"] = "Maintenance Staff";
    //endregion
})(RoleTypesEnum = exports.RoleTypesEnum || (exports.RoleTypesEnum = {}));
//# sourceMappingURL=role.enums.js.map